import http from "@/shared/axios-config/g-http-metodos";

function getOrcamentosFiltrados(filtros){
    const { res, erro, requisicao } = http.postArray('GerarNovoPedido/GetOrcamentosFiltrados', filtros)
    return { OrcamentoArray: res, erro, requisicao }
}

function getQuantidadesPedido(orcamentoId){
    const { res, erro, requisicao } = http.getArray(`GerarNovoPedido/GetQuantidadesPedido/${orcamentoId}`)
    return { QuantidadeArray: res, erro, requisicao }
}

function GetInformacaoTipoPedidoEnum() {
    const { res, erro, requisicao } = http.getArray('pedido/GetTipoPedidoEnum')
    return { TipoPedidoArray: res, erro, requisicao }
}

const GerarNovoPedidoController = {
    getOrcamentosFiltrados,
    getQuantidadesPedido,
    GetInformacaoTipoPedidoEnum
}

export default GerarNovoPedidoController;

